var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTaskStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 35,
    viewBox: "0 0 34 35",
    width: 34,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17.1738,
    fill: "#dadbdd",
    r: 17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m13.1203 20.918c-.0312.0047-.0625.0078-.0937.0078-.1391 0-.2688-.0547-.3719-.1547-.1234-.1234-.1766-.2922-.1469-.4656l.461-2.6282c.0062-.0312.0203-.0593.0437-.0828l6.6234-6.6234c.0297-.0297.0688-.0453.111-.0453s.0812.0156.1109.0453l2.5969 2.5984c.0609.061.0609.1594 0 .2203l-6.6234 6.6235c-.0219.0234-.0516.0375-.0829.0437zm-1.8703 1.3203h11.5c.2766 0 .5.2234.5.5v.5625c0 .0687-.0562.125-.125.125h-12.25c-.0687 0-.125-.0563-.125-.125v-.5625c0-.2766.2234-.5.5-.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTaskStart);
export default __webpack_public_path__ + "static/media/icon-task-start.5dfb927b8b4584c1c8683e533f0bca4d.svg";
export { ForwardRef as ReactComponent };